import React, { useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';
import UploadBar from '@components/UploadBar';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import RemoveIcon from '@assets/icons/removeIcon';
import ErrorIcon from '@assets/icons/errorIcon';
import RetryIcon from '@assets/icons/retryIcon';
import C from '@assets/themes/colors';

const UpdatingFileBar:React.FC<IProps> = (props) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    var value = false;
    if (props.newFile.status === 2) {
      if (props.newFile.svg) {
        var svgFile = props.newFile.svg.toString();
        var findError = svgFile.search("This page contains the following errors");
        if (findError >=0 ) {
          value = true;
        }
      } else {
        value = true;
      }
    }
    setHasError(value);
  }, [props.newFile])

  const renderFileName = () => {
    var fileName = props.newFile.file.name.toString();
    if (fileName.length > 50)
      fileName = fileName.substr(0, 50) + "..."
    return fileName;
  }

  const renderProgressBar = () => {
    var progress = 0;
    if (props.newFile.canvasLength) {
      progress = (props.fileProgress.progress / props.newFile.canvasLength) * 100;
    }
    return (
      <>
        {
          progress === 100 || props.fileProgress.hasErrors === true ?
            <S.CheckIcon>
              {
                props.fileProgress.hasErrors === true ?
                  <S.RetryContainer onClick={handleClickRetry} >
                    <RetryIcon />
                    <S.RetryLabel>
                      Retry
                    </S.RetryLabel>
                  </S.RetryContainer>
                :
                  <BlackCheckIcon />
              }
            </S.CheckIcon>
          :
            <UploadBar width={51} height={12} progress={progress} />
        }
      </>
    )
  } 

  const renderTagStatus = (tags: any) => {
    return (
      <>
        {
          tags && tags.designType && tags.platform && tags.formats && tags.oem ?
            <S.CheckIcon>
              <BlackCheckIcon />
            </S.CheckIcon>
          :
            "Untagged"
        }
      </>
    )
  } 

  const handleClick = () => {
    props.setCurrentIndex(props.fileIndex);
  }

  const handleClickRetry = () => {
    props.handleRetryUpload(props.fileIndex);
  }

  return (
    <S.Root onClick={handleClick} >
      <S.FileContainer  backgroundColor={props.fileIndex === props.currentIndex ? C.GRAY : C.WHITE}>
        <S.FileNameLabel>
          {renderFileName()}
          {
            hasError &&
            <S.ErrorIconContainer>
              <ErrorIcon />
            </S.ErrorIconContainer>
          }
        </S.FileNameLabel>
        <S.FileUploadLabel>
          {renderProgressBar()}
        </S.FileUploadLabel>
        <S.FileTagLabel>
          {renderTagStatus(props.newFile.tags)}
        </S.FileTagLabel>
        <S.RemoveIconContainer onClick={() => props.handleDeteleTemplate(props.fileIndex)} >
          <RemoveIcon />
        </S.RemoveIconContainer>
      </S.FileContainer>
    </S.Root >
  );
}

export default UpdatingFileBar;